import { LoginFormTabs } from './LoginFormTabs';
export default LoginFormTabs;
